import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../styles/colors';

const Panel = styled.div`
  margin-top: 12px;
  padding: 12px 16px;
  border: 1px solid ${colors.shades.gamma3};
  border-radius: 8px;
  background-color: ${colors.shades.alpha2};
  max-width: 600px;
`;

const PanelTitle = styled(Typography)`
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
  color: ${colors.shades.gamma10};
  margin-bottom: 8px;
`;

const TermsList = styled.ul`
  margin: 0;
  padding-left: 18px;
`;

const TermItem = styled.li`
  font-size: 13px;
  line-height: 18px;
  color: ${colors.shades.gamma10};
  margin-bottom: 4px;
`;

export {
  Panel,
  PanelTitle,
  TermsList,
  TermItem,
};
